module.exports = "//d274d294w9cx2v.cloudfront.net/c35a81a0b36a7fe83fb089436d040ede4ca7e4a6/images/registryDefaultSmall.webp";